<template> 
  <el-form ref="baseForm" label-width="100px" class="dialog-from flex" :rules="rules" :model="fromData">
    <el-form-item class="item" label="单位编码：" prop="unitCode">
      <el-input type="text" placeholder="请输入" v-model="fromData.unitCode"></el-input>
    </el-form-item>

    <el-form-item class="item" label="单位描述：" prop="unitDesc">
      <el-input type="text" placeholder="请输入" v-model="fromData.unitDesc"></el-input>
    </el-form-item>

    <el-form-item class="item" label="公司：" prop="company">
      <CompanyEyeInput size="medium" :value="fromData.companyName" windowToBody @onEyeChange="onEyeChange"></CompanyEyeInput> 
    </el-form-item>
  </el-form>
</template>

<script>
import CompanyEyeInput from 'busicomponent/input/company/CompanyEyeInput.vue'
export default {
  components: {CompanyEyeInput},
  props: {
    fromData: Object
  },
  data() {
    return {
      textarea: "",
      rules: {
      }
    };
  },
  created() {},
  methods: {
    validataForm() {
      this.$refs["baseForm"].validate(vaild => {
        this.fromData.regRes = vaild;
      });
    },
    onEyeChange(companyRow){
      console.log(companyRow) 
           if(companyRow){
            this.$emit("CompanyData",companyRow);
              //  this.fromData.companyId=companyRow.companyId;
              //  this.fromData.companyCode=companyRow.companyCode;
              //  this.fromData.companyName=companyRow.companyName;
           }
    },
  }
};
</script>

<style>
</style>
